// extracted by mini-css-extract-plugin
export default {"formContainer":"NewWish_formContainer__tL1KB"};